import {
  clearSessionItem,
  readSessionItemWithLocalFallback,
  writeSessionItem,
} from './session-storage'

export interface User {
  id: string
  email: string
  name: string | null
}

export interface AuthSession {
  accessToken: string
  expiresAt: string
}

export interface AuthState {
  user: User | null
  session: AuthSession | null
  isAuthenticated: boolean
}

const STORAGE_KEY = 'statureboost_auth_v1'

const EMPTY_STATE: AuthState = {
  user: null,
  session: null,
  isAuthenticated: false,
}

export function getAuthState(): AuthState {
  const stored = readSessionItemWithLocalFallback(STORAGE_KEY)
  if (!stored) {
    return EMPTY_STATE
  }

  try {
    const parsed = JSON.parse(stored) as Partial<AuthState>
    const user = parsed.user ?? null
    const session = parsed.session ?? null

    return {
      user,
      session,
      isAuthenticated: Boolean(user && session?.accessToken),
    }
  } catch {
    return EMPTY_STATE
  }
}

export function setAuthState(user: User, session: AuthSession): void {
  const nextState: AuthState = {
    user,
    session,
    isAuthenticated: true,
  }

  writeSessionItem(STORAGE_KEY, JSON.stringify(nextState))
}

export function clearAuthState(): void {
  clearSessionItem(STORAGE_KEY)
}

export function getAccessToken(): string | null {
  return getAuthState().session?.accessToken ?? null
}

export function isAuthenticated(): boolean {
  return getAuthState().isAuthenticated
}

export function isAuthBypassEnabled(): boolean {
  return false
}
